import { useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

export const STATUS_LABEL = { todo: "To do", in_progress: "In progress", in_review: "In review", done: "Done" };
export const STATUSES = ["todo", "in_progress", "in_review", "done"];
export const PRIORITIES = ["low", "medium", "high", "urgent"];
export const WORK_TYPES = ["task", "issue", "request"];
export const TYPE_TONE = { task: "neutral", issue: "danger", request: "info" };

export const today = () => new Date().toISOString().slice(0, 10);
export const isOverdue = (t) => t.due_date && t.status !== "done" && t.due_date < today();
export const fmtDate = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString(undefined, { month: "short", day: "numeric" }) : "");
export const initials = (n = "") => n.split(" ").map((s) => s[0]).join("").slice(0, 2).toUpperCase();

let metaCache = null;
export function useWorkMeta() {
  const [meta, setMeta] = useState(metaCache);
  useEffect(() => { if (!metaCache) api.get("/work/meta").then((r) => { metaCache = r.data; setMeta(r.data); }).catch(() => {}); }, []);
  const people = useMemo(() => meta?.people || [], [meta]);
  const person = useCallback((id) => people.find((p) => p.id === id), [people]);
  return { meta, people, person };
}

export function useItems(params, deps = []) {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => api.get("/work/items", { params }).then((r) => { setItems(r.data); setErr(null); }).catch((e) => setErr(e)), deps); // eslint-disable-line
  useEffect(() => { load(); }, [load]);
  return { items, err, reload: load, setItems };
}

export function useBoards() {
  const [data, setData] = useState(null);
  const load = useCallback(() => api.get("/work/boards").then((r) => setData(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  return { boards: data?.boards || [], pinned: data?.pinned || [], hidden: data?.hidden || [], reload: load, ready: !!data };
}

export const patchItem = (id, patch) => api.patch(`/work/items/${id}`, patch).then((r) => r.data);
